var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.showInputPostalCode)?_c('postalcode',{attrs:{"screenParams":_vm.screenParams}}):_c('residence',{attrs:{"screenParams":_vm.screenParams}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6168342","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!(webpack)-strip-block??ref--0-0!(webpack)-strip-block??ref--1-0!(webpack)-strip-block??ref--2-0!(webpack)-strip-block??ref--3-0!(webpack)-strip-block??ref--4-0!./src/screens/PersonalPostalCode.vue
// module id = 2543
// module chunks = 17